import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface PropsTypes {
  value: string;
  placeholder: string;
  label?: string;
  onUpdate: (b: string) => void;
  textfieldProps?: TextFieldProps;
}

const EditableField = (props: PropsTypes) => {
  const [value, setValue] = React.useState(props.value || '');

  const handleSubmit = React.useCallback(() => {
    if (props.value !== value) {
      props.onUpdate(value);
    }
  }, [props, value]);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <TextField
      variant="standard"
      {...(props.textfieldProps || {})}
      label={props.label}
      placeholder={props.placeholder || ''}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSubmit();
          (e.target as HTMLElement).blur();
        }
      }}
      onBlur={handleSubmit}
      InputProps={{
        style: { whiteSpace: 'nowrap' }
      }}
    />
  );
};

export default EditableField;